import { Calendar, Clock, MapPin, Phone, Stethoscope } from "@/components/icons";

function Row({ icon: Icon, label, children }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-9 h-9 shrink-0 rounded-full bg-[#F5F5F5] flex items-center justify-center">
        {Icon ? <Icon className="w-4 h-4 text-black/70" strokeWidth={1.8} /> : null}
      </div>
      <div className="flex-1">
        <div className="text-[10px] font-bold uppercase tracking-widest text-black/45">
          {label}
        </div>
        <div className="text-black text-[15px] leading-tight mt-1">{children}</div>
      </div>
    </div>
  );
}

export default function AppointmentDetails({ data }) {
  const a = data.appointment;
  const doctorName = data.doctor.name?.match(/^\s*dr\.?\s+/i)
    ? data.doctor.name
    : `Dr. ${data.doctor.name}`;

  return (
    <div className="bg-white rounded-2xl p-5 space-y-4">
      <Row icon={Stethoscope} label="Doctor">
        <strong>{doctorName}</strong>
      </Row>
      <Row icon={Calendar} label="Fecha">
        <strong>{a.date_human}</strong>
      </Row>
      <Row icon={Clock} label="Hora">
        <strong>{a.time_human || "—"}</strong>
        <span className="text-black/55"> · {a.duration_min} min</span>
      </Row>
      <Row icon={MapPin} label="Consultorio">
        <div>
          <strong>{data.office.name || "Sin especificar"}</strong>
          {data.office.address ? (
            <div className="text-black/60 text-sm">{data.office.address}</div>
          ) : null}
        </div>
      </Row>
      {data.office.phone ? (
        <Row icon={Phone} label="Teléfono">
          <a
            href={`tel:${data.office.phone}`}
            className="text-black hover:text-[#01BC8E] font-bold transition"
          >
            {data.office.phone}
          </a>
        </Row>
      ) : null}
      {a.reason ? (
        <Row label="Motivo">
          <span className="text-black/80">{a.reason}</span>
        </Row>
      ) : null}
    </div>
  );
}
